import pick from 'lodash/fp/pick';

import config from '@config';

import createDataSource from '../createDataSource';
import { getDefaultEmptyList, getDefaultListHandler, makeGetByIds } from '../utils';

const BASE_PATHNAME = 'competitions';

export default () => {
  const dataSource = createDataSource(`${config.api.url}`);

  const getByIds = makeGetByIds({ dataSource, url: `${BASE_PATHNAME}/getmany` });
  const getById = async ({ id }) => {
    // FIXME: a hack. Remove when have API
    const result = await getByIds({ ids: [id] });
    return result[0];
  };

  const getAppearance = ({ id }) => dataSource.get(`${BASE_PATHNAME}/${id}/appearance`).json();
  const createAppearance = ({ id, values }) =>
    dataSource.post(`${BASE_PATHNAME}/appearance`, { json: { ...values, competitionId: id } }).json();
  const updateAppearance = ({ id, values }) =>
    dataSource.put(`${BASE_PATHNAME}/appearance`, { json: { ...values, competitionId: id } }).json();
  const upsertAppearance = ({ id, hasBeenCreated, values }) =>
    hasBeenCreated ? updateAppearance({ id, values }) : createAppearance({ id, values });

  return {
    getList: getDefaultListHandler({
      url: BASE_PATHNAME,
      dataSource,
      transformFilter: pick(['category', 'urlSlug']),
    }),

    getById,

    getByIds,

    getEmptyList: getDefaultEmptyList,

    getAppearance,
    createAppearance,
    updateAppearance,
    upsertAppearance,
  };
};
